// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--main-bg);
  padding: 1.5rem;
}

.login-card {
  width: 100%;
  max-width: 400px;
  background: var(--card-bg);
  border-radius: var(--radius);
  box-shadow: var(--card-shadow);
  padding: 2rem;
  border: 1px solid var(--border);
}

.login-card-header {
  text-align: center;
  margin-bottom: 1.75rem;
}

.login-logo {
  width: 200px;
  height: 56px;
  object-fit: contain;
  margin-bottom: 1rem;
}

.login-card-header h1 {
  margin: 0 0 0.35rem;
  font-size: 1.5rem;
  font-weight: 600;
  color: var(--text);
}

.login-card-header p {
  margin: 0;
  font-size: 0.875rem;
  color: var(--text-muted);
}

.login-form {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

.login-error {
  padding: 0.65rem 1rem;
  font-size: 0.85rem;
  color: #b91c1c;
  background: #fef2f2;
  border-radius: var(--radius);
}

.login-attempts {
  font-weight: 600;
  display: block;
  margin-top: 0.35rem;
}

.login-label {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--text);
}

.login-input {
  padding: 0.65rem 1rem;
  font-size: 0.9rem;
  font-family: inherit;
  border: 1px solid var(--border);
  border-radius: var(--radius);
  background: #fff;
  color: var(--text);
  transition: border-color 0.2s;
}

.login-input::placeholder {
  color: var(--text-muted);
}

.login-input:focus {
  outline: none;
  border-color: var(--primary);
}

.login-submit {
  margin-top: 0.5rem;
  padding: 0.75rem 1rem;
  font-size: 0.95rem;
  font-weight: 600;
  color: #fff;
  background: var(--primary);
  border: none;
  border-radius: var(--radius);
  cursor: pointer;
  transition: opacity 0.2s;
}

.login-submit:hover {
  opacity: 0.92;
}

.login-demo-hint {
  margin: 1.25rem 0 0;
  font-size: 0.75rem;
  color: var(--text-muted);
  text-align: center;
}

.login-otp-hint {
  margin: 0 0 0.5rem;
  font-size: 0.85rem;
  color: var(--text-muted);
}

.login-otp-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.75rem;
  margin-top: 1rem;
}

.login-resend,
.login-back {
  padding: 0.5rem 0.75rem;
  font-size: 0.875rem;
  color: var(--primary);
  background: transparent;
  border: none;
  cursor: pointer;
  text-decoration: underline;
  transition: opacity 0.2s;
}

.login-resend:disabled,
.login-back:disabled {
  color: var(--text-muted);
  cursor: not-allowed;
  text-decoration: none;
  opacity: 0.7;
}

.login-resend:hover:not(:disabled),
.login-back:hover:not(:disabled) {
  opacity: 0.85;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Login/LoginPage.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,0BAA0B;EAC1B,4BAA4B;EAC5B,8BAA8B;EAC9B,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,+BAA+B;EAC/B,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,0BAA0B;EAC1B,YAAY;EACZ,4BAA4B;EAC5B,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;EAEE,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,0BAA0B;EAC1B,wBAAwB;AAC1B;;AAEA;;EAEE,wBAAwB;EACxB,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;AACd;;AAEA;;EAEE,aAAa;AACf","sourcesContent":[".login-page {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--main-bg);\n  padding: 1.5rem;\n}\n\n.login-card {\n  width: 100%;\n  max-width: 400px;\n  background: var(--card-bg);\n  border-radius: var(--radius);\n  box-shadow: var(--card-shadow);\n  padding: 2rem;\n  border: 1px solid var(--border);\n}\n\n.login-card-header {\n  text-align: center;\n  margin-bottom: 1.75rem;\n}\n\n.login-logo {\n  width: 200px;\n  height: 56px;\n  object-fit: contain;\n  margin-bottom: 1rem;\n}\n\n.login-card-header h1 {\n  margin: 0 0 0.35rem;\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: var(--text);\n}\n\n.login-card-header p {\n  margin: 0;\n  font-size: 0.875rem;\n  color: var(--text-muted);\n}\n\n.login-form {\n  display: flex;\n  flex-direction: column;\n  gap: 1.25rem;\n}\n\n.login-error {\n  padding: 0.65rem 1rem;\n  font-size: 0.85rem;\n  color: #b91c1c;\n  background: #fef2f2;\n  border-radius: var(--radius);\n}\n\n.login-attempts {\n  font-weight: 600;\n  display: block;\n  margin-top: 0.35rem;\n}\n\n.login-label {\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: var(--text);\n}\n\n.login-input {\n  padding: 0.65rem 1rem;\n  font-size: 0.9rem;\n  font-family: inherit;\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  background: #fff;\n  color: var(--text);\n  transition: border-color 0.2s;\n}\n\n.login-input::placeholder {\n  color: var(--text-muted);\n}\n\n.login-input:focus {\n  outline: none;\n  border-color: var(--primary);\n}\n\n.login-submit {\n  margin-top: 0.5rem;\n  padding: 0.75rem 1rem;\n  font-size: 0.95rem;\n  font-weight: 600;\n  color: #fff;\n  background: var(--primary);\n  border: none;\n  border-radius: var(--radius);\n  cursor: pointer;\n  transition: opacity 0.2s;\n}\n\n.login-submit:hover {\n  opacity: 0.92;\n}\n\n.login-demo-hint {\n  margin: 1.25rem 0 0;\n  font-size: 0.75rem;\n  color: var(--text-muted);\n  text-align: center;\n}\n\n.login-otp-hint {\n  margin: 0 0 0.5rem;\n  font-size: 0.85rem;\n  color: var(--text-muted);\n}\n\n.login-otp-actions {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 0.75rem;\n  margin-top: 1rem;\n}\n\n.login-resend,\n.login-back {\n  padding: 0.5rem 0.75rem;\n  font-size: 0.875rem;\n  color: var(--primary);\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  text-decoration: underline;\n  transition: opacity 0.2s;\n}\n\n.login-resend:disabled,\n.login-back:disabled {\n  color: var(--text-muted);\n  cursor: not-allowed;\n  text-decoration: none;\n  opacity: 0.7;\n}\n\n.login-resend:hover:not(:disabled),\n.login-back:hover:not(:disabled) {\n  opacity: 0.85;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
